@use 'kci-design-lib/styles/variables.scss' as *;
.flag-container {
  text-align: center;
  display: inline-flex;
}
.flag-wrapper {
  display: inline-flex;
  img {
    object-fit: cover;
  }
}
.flag {
  display: inline-block;
  border: none;
  height: auto;
}
.flag-circle {
  border-radius: 50%;
  &.flag-xsmall {
    width: 24px;
    height: 24px;
  }
  &.flag-small {
    width: 32px;
    height: 32px;
  }
  &.flag-medium {
    width: 40px;
    height: 40px;
  }
  &.flag-large {
    width: 48px;
    height: 48px;
  }
  &.flag-xlarge {
    width: 56px;
    height: 56px;
  }
}
.flag-square {
  border-radius: 4px;
  &.flag-xsmall {
    width: 24px;
    height: 24px;
  }
  &.flag-small {
    width: 32px;
    height: 32px;
  }
  &.flag-medium {
    width: 40px;
    height: 40px;
  }
  &.flag-large {
    width: 48px;
    height: 48px;
  }
  &.flag-xlarge {
    width: 56px;
    height: 56px;
  }
}
.flag-round {
  border-radius: 4px;
  &.flag-xsmall {
    width: 36px;
    height: 24px;
  }
  &.flag-small {
    width: 48px;
    height: 32px;
  }
  &.flag-medium {
    width: 60px;
    height: 40px;
  }
  &.flag-large {
    width: 72px;
    height: 48px;
  }
  &.flag-xlarge {
    width: 84px;
    height: 56px;
  }
}
